import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=6088b6fa&scoped=true"
import script from "./listInfo.vue?vue&type=script&lang=js"
export * from "./listInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088b6fa",
  null
  
)

export default component.exports